import { useQuery } from "@tanstack/react-query";
import { FC, useState } from "react";
import { getEquipmentQuantityByBlockCode } from "../../../../../core/api/services/dashbaorad-details/location-block.services";
import InfoTileContainer from "../../../../../shared-elements/info-tile/info-tile-container.component";
import InfoTileComponent from "../../../../../shared-elements/info-tile/info-tile.component";
import GatewayModalComponent from "./gateway-modal.component";
import LuminaryModalComponent from "./luminary-modal.component";

interface EquipmentQuantityComponentTypes {
  blockCode: any;
  isRefreshedEquipmentQuantity: boolean;
}

const EquipmentQuantityComponent: FC<EquipmentQuantityComponentTypes> = ({
  blockCode,
  isRefreshedEquipmentQuantity,
}) => {
  const [isGatewayModalOpen, setIsGatewayModalOpen] = useState<boolean>(false);
  const [isLuminaryModalOpen, setIsLuminaryModalOpen] =
    useState<boolean>(false);

  const {
    data: equipmentQuantity,
    isLoading: isLoadingEquipmentQuantityByBlockCode,
  } = useQuery({
    queryKey: ["getEquipmentQuantityByBlockCode", blockCode],
    queryFn: ({ signal }) => getEquipmentQuantityByBlockCode(blockCode, signal),
    enabled: !!blockCode,
  });

  const gatewayModalHandler = (value: any) => {
    if (value <= 0) return;

    setIsGatewayModalOpen(true);
  };

  const luminaryModalHandler = (value: any) => {
    if (value <= 0) return;

    setIsLuminaryModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsGatewayModalOpen(false);
    setIsLuminaryModalOpen(false);
  };

  return (
    <>
      <div>
        <InfoTileContainer header="Equipment Quantity" minHeight="170px">
          <InfoTileComponent
            title="Luminaire Quantity"
            value={equipmentQuantity?.data?.luminarieQuantity}
            onClickEvent={() =>
              Number(equipmentQuantity?.data?.luminarieQuantity) == 0
                ? null
                : luminaryModalHandler(
                  equipmentQuantity?.data?.luminarieQuantity
                )
            }
            className={` ${Number(equipmentQuantity?.data?.luminarieQuantity) > 0
              ? "cursor-pointer link-color"
              : "text-black "
              }  `}
            isLoading={
              isLoadingEquipmentQuantityByBlockCode ||
              isRefreshedEquipmentQuantity
            }
            valueWidth={1}
          />

          <InfoTileComponent
            title="Gateway Quantity"
            value={equipmentQuantity?.data?.gatewayQuantity}
            onClickEvent={() =>
              Number(equipmentQuantity?.data?.gatewayQuantity) == 0
                ? null
                : gatewayModalHandler(equipmentQuantity?.data?.gatewayQuantity)
            }
            className={` ${Number(equipmentQuantity?.data?.gatewayQuantity) > 0
              ? "cursor-pointer link-color"
              : "text-black "
              }  `}
            isLoading={
              isLoadingEquipmentQuantityByBlockCode ||
              isRefreshedEquipmentQuantity
            }
            valueWidth={1}
          />
        </InfoTileContainer>
      </div>
      <GatewayModalComponent
        isGatewayModalOpen={isGatewayModalOpen}
        blockCode={blockCode}
        handleCloseModal={handleCloseModal}
      />

      <LuminaryModalComponent
        isLuminaryModalOpen={isLuminaryModalOpen}
        blockCode={blockCode}
        handleCloseModal={handleCloseModal}
      />
    </>
  );
};

export default EquipmentQuantityComponent;
